import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "./axiosBaseQuery";
import {buildHotYoterBenefitsSearchUrl} from "../../containers/hot_yoter/utils/buildHotYoterSearchParams";

const baseSearchApi = '/search/api';
const baseCmsApi = '/api/website/2.0'


export const searchApi = createApi({
    reducerPath: 'searchApi',
    baseQuery: axiosBaseQuery({}),
    tagTypes: ['search'],
    endpoints: (build) => ({
        search: build.query({
            query: (params) => ({
                url: baseSearchApi + '/',
                params
            })
        }),
        getSearchFilters: build.query({
            query: ({fields, filters}) => ({
                url: baseSearchApi + '/benefits/',
                params: {fields, filters, size: 1}
            }),
            transformResponse(baseQueryReturnValue ) {
                const filters = baseQueryReturnValue.benefits.metadata.filters
                return filters.reduce((agg, f) => {
                    agg[f.inputName] = f.values
                    return agg
                }, {})
            }
        }),
        searchBenefits: build.query({
            query: (params) => ({
                url: baseSearchApi + '/benefits/',
                params
            })
        }),
        searchHotYoterBenefits: build.query({
            query: ({
                benefitGroupIds = [],
                selectedCategoryId,
                page = 1,
            }) => ({
                url: buildHotYoterBenefitsSearchUrl({
                    benefitGroupIds,
                    selectedCategoryId,
                    page,
                }),
            }),
        }),
        searchArticles: build.query({
            query: (params) => ({
                url: baseSearchApi + '/articles/',
                params
            })
        }),
        searchCategoryBenefits: build.query({
            query: (params) => ({
                url: baseCmsApi + '/getCategoryBenefits/',
                params
            })
        }),
        getAllBenefits: build.query({
            query: (params) => ({
                url: baseCmsApi + '/getAllBenefits/',
                params
            })
        }),
        getSelectedBenefits: build.query({
            query: (params) => {
                const ids = [].concat(params?.ids || []);
                const searchParams = new URLSearchParams();
                ids.forEach((id) => searchParams.append('ids', id));
                const query = searchParams.toString();
                return {
                    url: `${baseSearchApi}/selected-benefits/${query ? `?${query}` : ''}`,
                    popupOnError: false,
                };
            },
            transformErrorResponse() {
                return { data: [], popupOnError: false }
            },
        })

    })
})


export const {
    useGetAllBenefitsQuery,
    useSearchQuery,
    useSearchBenefitsQuery,
    useSearchArticlesQuery,
    useSearchCategoryBenefitsQuery,
    useGetSearchFiltersQuery,
    useGetSelectedBenefitsQuery,
    useSearchHotYoterBenefitsQuery,
} = searchApi
